import { createApi } from '@reduxjs/toolkit/query/react';

import {
  RobotAttachmentsEndpoints as Endpoints,
  type GetRobotAttachmentsListRequest,
  type GetRobotAttachmentsListResponse,
  type UploadRobotAttachmentRequest,
  type UploadRobotAttachmentResponse,
} from '@app/api/RobotAttachments/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { SALES_FUNNELS_STAGES_ROBOTS_CHUNK } from '@app/constants';

export const robotAttachmentsApi = createApi({
  reducerPath: 'robotAttachmentsApi',
  baseQuery: createApiBaseQuery(
    `${SALES_FUNNELS_STAGES_ROBOTS_CHUNK}/Attachments`
  ),
  endpoints: ({ mutation, query }) => ({
    [Endpoints.UploadRobotAttachment]: mutation<
      UploadRobotAttachmentResponse,
      UploadRobotAttachmentRequest
    >({
      query: ({ data, ...params }) => ({
        url: 'Upload',
        method: Methods.POST,
        params,
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
    }),
    [Endpoints.GetRobotAttachmentsList]: query<
      GetRobotAttachmentsListResponse,
      GetRobotAttachmentsListRequest
    >({
      query: (params) => ({
        url: 'List',
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useUploadRobotAttachmentMutation,
  useGetRobotAttachmentsListQuery,
  useLazyGetRobotAttachmentsListQuery,
} = robotAttachmentsApi;
